<div class="basket">
    <div class="close">
        <button (click)="closeOverLay()"
                [attr.aria-label]="'MINIBASKET.CLOSE' | translate">
            <app-svg use="close"
                     aria-hidden="true"></app-svg>
        </button>
    </div>
    <div class="head">
        <span>{{ 'MINIBASKET.TITLE' | translate }}</span>
        <span class="quantity">({{ quantity$ | async }})</span>
    </div>
    @if(basket$ | async; as basket) {
        @if(basket?.lines?.length > 0) {
        <div class="content">
                <a [routerLink]="line?.productUrl"
                   class="line"
                   (click)="closeOverLay()"
                   *ngFor="let line of basket?.lines">
                    <div class="line-main">
                        <div class="line-image">
                            <img class="line-image-element"
                                 [use]="line?.imageUrl"
                                 [query]="{width: 690, height:690, }"
                                 [title]="line?.name">
                        </div>
                        <div class="line-content">
                            <p class="line-name">{{ line?.name }}</p>
                            <p class="line-variations">
                                @for(variantOption of line?.variantOptions; track $index){
                                    <span class="line-variation">
                                        <span class="line-variation-title">{{variantOption.title}}</span>
                                        <span class="line-variation-value">{{variantOption.value}}</span>
                                    </span>
                                }
                            </p>
                            <p class="line-category">{{ line?.quantity }}</p>
                            <span class="line-price">
                                <span class="line-list-price">{{ line?.totalPrice?.listPrice | price }} </span>
                                <span class="line-sales-price"> {{ line?.totalPrice?.salesPrice | price }} </span>
                            </span>
                        </div>
                    </div>
                </a>
        </div>

        <app-basket-summary [basket]="basket"></app-basket-summary>
        } @else {
            <div class="line empty"> {{ 'MINIBASKET.EMPTY' | translate }} </div>
        }
    } @else {
        <div class="line empty"> {{ 'MINIBASKET.EMPTY' | translate }} </div>
    }
    <div class="footer">
        <button class="back">{{ 'MINIBASKET.CLOSE' | translate }}</button>
        <a class="footer-line button"
           [routerLink]="basketLink">{{ 'MINIBASKET.NAVIGATE_TO_CHECKOUT' | translate }}</a>
    </div>
</div>
